import { render, staticRenderFns } from "./form.vue?vue&type=template&id=0a2ff8be&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=0a2ff8be&scoped=true&lang=scss"
import style1 from "./form.vue?vue&type=style&index=1&id=0a2ff8be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ff8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2ff8be')) {
      api.createRecord('0a2ff8be', component.options)
    } else {
      api.reload('0a2ff8be', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=0a2ff8be&scoped=true", function () {
      api.rerender('0a2ff8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/form.vue"
export default component.exports